export default __webpack_public_path__ + "static/media/1.664a6fbd.jpg";